import { hostFactory as hostInstance } from "../factory";

const PATH = "/api/my/profile";

const me = (verb = "get", data) => hostInstance[verb](PATH, data);

const myProfile = () => hostInstance.get("/api/accounts/profile");

export { myProfile };

export default me;
